import { h, Fragment } from "preact";
import { useContext } from "preact/hooks";
import { IdPrefixContext } from "../../helpers/idPrefixContext";

export default function ProductOptionPill({
  optionValue,
  optionName,
  disabled,
  updateOptionValue,
  selected,
}) {
  const idPrefix = useContext(IdPrefixContext);

  return (
    <label className="product-options__pill-wrapper">
      <input
        type="radio"
        name={`${idPrefix}${optionName}`}
        value={optionValue.name}
        className="product-options__pill-input"
        onChange={(e) => updateOptionValue(e.target.value)}
        checked={selected}
      />
      <div className="product-options__pill">
        <div
          className={`product-options__pill-inner ${disabled ? "product-options__pill-inner--disabled" : ""}`}
        >
          <span>{optionValue.name}</span>
          {disabled && (
            <div className="product-options__pill-disabled-slash"></div>
          )}
        </div>
      </div>
    </label>
  );
}
